import { cn } from "../../../lib/utils";
import { SummaryLine } from "./summary-line";
import { ClipboardDocumentIcon } from "@heroicons/react/24/outline";
import { PaymentDetailsPreviewProps } from "./types";

export const PaymentDetailsHeader = ({
	title,
	updatedAt,
	investmentId,
	createdAt,
}: Pick<
	PaymentDetailsPreviewProps,
	"title" | "updatedAt" | "investmentId" | "createdAt"
>) => (
	<>
		<div>
			{title && <h5 className={cn("text-lg font-extrabold pt-4")}>{title}</h5>}
			{updatedAt && (
				<p className={cn("text-xs font-light text-gray-500")}>
					Last updated: {updatedAt?.toString()}
				</p>
			)}
		</div>
		{investmentId && (
			<SummaryLine
				field="Investment ID"
				value={
					<div>
						<div className="flex flex-row bg-slate-50 px-1 text-xs gap-1 rounded border items-center w-fit">
							<p className="truncate text-ellipsis w-[70px] leading-4">
								{investmentId}
							</p>
							<ClipboardDocumentIcon
								stroke="#1F2937"
								strokeWidth={2}
								onClick={() => navigator.clipboard.writeText(investmentId)}
								className="cursor-pointer"
								width={12}
								height={12}
							/>
						</div>
					</div>
				}
				isText
			/>
		)}
		{createdAt && (
			<SummaryLine field="Date" value={createdAt?.toString()} isText />
		)}
	</>
);
